import {cs}                              from "@Common/react/chain-services";
import {consumeContext, provideContext1} from "@Common/react/context";
import {fragments}                       from "@Common/react/fragments";
import {Invoke}                          from "@Common/react/invoke";
import {keyed}                           from "@Common/react/keyed";
import {stateChangeNestedValue}          from "@Common/react/state-change-nested-value";
import {UseState}                        from "@Common/react/use-state";

export const loadCart2 = (next) => cs(
    ["state", (_, next) => UseState({next})],

    consumeContext("apis"),
    consumeContext("session"),
    ["cart", ({state, session, apis}, next) => {
        const key = JSON.stringify(session.value);
        return fragments(
            next(
                session.loading || !state.value || key !== state.value.key ? {
                    loading: true,
                } : {
                    value: state.value.value,

                    onChange: (cart) => {
                        stateChangeNestedValue(state, ["value"], () => cart);
                    },
                }
            ),

            !session.loading && cs(
                keyed(key),
                () => Invoke({
                    action: async () => {
                        const cart = await apis.next.cart.getCurrentCart();
                        state.onChange({
                            key,
                            value: cart,
                        });
                    },
                }),
            ),
        );
    }],
    ({cart}) => provideContext1("cart", cart, next),
);
